import React, { Component } from 'react';
import { Saved } from './Saved';

class Header extends Component {
  render() {
    return (
      <div onClick={this.props.onSave} className="border-b py-2 px-3 font-bold flex justify-between items-center bg-gray-50 rounded">
        <span>{ this.props.title }</span>

        <Saved saved={this.props.saved} />
      </div>
    );
  }
}

export { Header };
